import type { Nullable, ToolName } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getImageAnnotatorToolIcon(tool: Nullable<ToolName>): IconName {
	switch (tool) {
		case "select":
			return "MousePointer2";
		case "polygon":
			return "VectorSquare";
		case "dimension":
			return "Ruler";
		case "text":
			return "Type";
		default:
			return "ToolCase";
	}
}
